import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=14b6c830"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b6c830')) {
      api.createRecord('14b6c830', component.options)
    } else {
      api.reload('14b6c830', component.options)
    }
    module.hot.accept("./CompanyView.vue?vue&type=template&id=14b6c830", function () {
      api.rerender('14b6c830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyView.vue"
export default component.exports